module.exports = __webpack_public_path__ + "media/images/admin/grid4-7a0df56d98adf39a3736c86bb88472b2.png";